module.exports = __webpack_public_path__ + "static/media/bankingbutton.d9000420.svg";